module.exports = require('./helpers/bundle-url').getBundleURL('gl7es') + "logo-dark.eefe0b7f.svg";